module.exports = __webpack_public_path__ + "img/2025-10-15a_4.f2f88197.jpg";